/* eslint-disable react/prop-types */

import React from "react";
import PublicationLinks from "../Publications/components/PublicationLinks";
import UserLink from "../atoms/Linkify/UserLink";

const conf = [
  {
    regexMatch: new RegExp(/PMID:\s*(\d+)/, "gi"),
    Renderer: ({ match }) => {
      const pubId = match.replace(/PMID:\s*/gi, "");
      return <PublicationLinks customText={match} ids={[pubId]} />;
    },
  },
  {
    regexMatch: new RegExp(/(?:\B)@[\w]+/, "g"),
    Renderer: ({ match }) => <UserLink userHandle={match} />,
  },
];

export default conf;
